import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetRubsByClientName = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_RUBS_BY_CLIENT_NAME + id, token);
  return res;
};
